import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export const useUploadDocument = () => {
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/application/document`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (res) => {
        // @ts-ignore
        queryClient.invalidateQueries("DOCUMENTS");
        setOpenModal(true);
      },
    }
  );

  return {
    openModal,
    setOpenModal,
    mutate,
    isLoading,
  };
};
